import { useState } from 'react';
// components
import {
  IEditForm,
  CasEditForm,
  CasDisplayField,
  CasRHFPercentField,
  CasRHFTextField,
} from 'src/compass/shared/components';
import {
  CasAsOfContainer,
  CasAsOfMultiRowTable,
  EntityInfoCMESalesCode,
  useDefaultAsOfValues,
} from 'src/compass/application/commissions';
import { CasRHFRiskWithSalesManagerSelect } from 'src/compass/application/general/components/CasRiskWithSalesManagerSelect';

// schema
import { CMESalesCodeSchema } from './CMESalesCodeSchema';
import AmountPerTradeOrPercent from './AmountPerTradeOrPercent';

// ----------------------------------------------------------------------

export default function CMESalesCodeForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};

  const [asofReadonly, setAsofReadonly] = useState(false);

  const defaultValues = useDefaultAsOfValues(row);

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity={EntityInfoCMESalesCode.entity}
      schema={CMESalesCodeSchema}
    >
      <CasDisplayField label="Sales Code" value={row?.officeSalesCode} />
      <CasRHFTextField name="description" label="Description" />

      <CasAsOfContainer
        entityTitle='CME Sales Code AsOf'
        entityId={id}
        deleteChildEntity="Cme/SalesCode/AsOf"
        initialAsOfList={row?.asOfs}
        initialAsOf={defaultValues.asOf}
        readOnly={asofReadonly}
        setReadOnly={setAsofReadonly}
      >
        <CasRHFPercentField name="asOf.payoutRate" label="Payout Rate" disabled={asofReadonly} />

        <CasAsOfMultiRowTable
          title="Payouts"
          readOnly={asofReadonly}
          name="asOf.asOfAddit"
          rowCountMode={0}
          helperText='$/Trade overrides currently incorrectly pay out on expiration "trades"'
          columns={[
            {
              type: 'component',
              label: 'Employee',
              name: 'employeeId',
              fullWidth: true,
              component: CasRHFRiskWithSalesManagerSelect,
            },
            {
              type: 'cells',
              label: 'Type',
              name: 'amountType',
              fullWidth: true,
              component: AmountPerTradeOrPercent,
            },
          ]}
        />
      </CasAsOfContainer>
    </CasEditForm>
  );
}
